var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { Alert } from '@one-thd/sui-atomic-components';
import { USER_FORM_MODE, } from '../../../models/b2b/add-manage-users';
import EditUserFormContent from './edit-user-form-content';
import AddUserFormContent from './add-user-form-content';
import { useManageUserForm } from '../../../hooks/use-manage-user-form';
import { ERR_GENERIC } from '../../../constants/response-error-messages';
import { manageUserUtils } from './manage-user-api-utils';
export var ManageUserForm = function (_a) {
    var formMode = _a.formMode, onCancel = _a.onCancel, onSuccess = _a.onSuccess, onError = _a.onError;
    var _b = useState(false), isManageUserError = _b[0], setManageUserError = _b[1];
    var _c = useManageUserForm(), formMethods = _c.formMethods, proTradeCreditError = _c.proTradeCreditError, editableUser = _c.editableUser, PTCsForUser = _c.PTCsForUser, hasProTradeCredit = _c.hasProTradeCredit;
    var addUser = manageUserUtils.addUser, editUser = manageUserUtils.editUser, handlePaymentPermissionsUpdate = manageUserUtils.handlePaymentPermissionsUpdate;
    var onValid = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isEditMode) {
                editUser(formData, editableUser)
                    .then(function (userData) {
                    // we need to update payment permissions only if the user has pro trade credit
                    // if the user type changes to Runner from a non-Runner we still need to update permissions by removing all current permissions
                    if (hasProTradeCredit) {
                        return handlePaymentPermissionsUpdate(userData.userId, formData.paymentPermissions, (PTCsForUser || []).map(function (_a) {
                            var paymentId = _a.paymentId;
                            return paymentId;
                        }))
                            .catch(function () {
                            // catch only update permissions errors
                            onError('permissionsFailure');
                        })
                            .then(function () {
                            return 'User updated successfully';
                        });
                    }
                    return 'User updated successfully';
                })
                    .then(function () {
                    onSuccess();
                })
                    .catch(function () {
                    onError('editUserFailure');
                    setManageUserError(true);
                });
            }
            else {
                addUser(formData)
                    .then(function (newUser) {
                    // the assumption is that users will not have permissions by default
                    // only the UI defaults to having all payments selected when creating a new user
                    if (formData.paymentPermissions &&
                        formData.paymentPermissions.length > 0 &&
                        formData.role !== 'Runner') {
                        return handlePaymentPermissionsUpdate(newUser.userId, formData.paymentPermissions, [])
                            .catch(function () {
                            // catch only update permissions errors
                            onError('permissionsFailure');
                        })
                            .then(function () {
                            // we still want to show a success message
                            // for adding the user even if there's an error updating permissions
                            return newUser.userInviteExpirationDate;
                        });
                    }
                    return newUser.userInviteExpirationDate;
                })
                    .then(function (expirationDate) {
                    onSuccess(expirationDate);
                })
                    .catch(function () {
                    // catch only add user errors
                    onError('addUserFailure');
                    setManageUserError(true);
                });
            }
            return [2 /*return*/];
        });
    }); };
    var isEditMode = formMode === USER_FORM_MODE.EDIT_USER;
    var handleCancel = function () {
        onCancel();
    };
    if (proTradeCreditError) {
        return (React.createElement("div", { "data-testid": "pro-trade-credit-fetch-error", className: "sui-pt-4" },
            React.createElement(Alert, { status: "error" }, ERR_GENERIC.message)));
    }
    return (React.createElement("form", { onSubmit: formMethods.handleSubmit(onValid) },
        React.createElement("div", { className: "sui-grid sui-gap-5 sui-grid-cols-12 lg:sui-grid-cols-9" }, isEditMode ? (React.createElement(EditUserFormContent, { isEditUserError: isManageUserError, onCancel: handleCancel })) : (React.createElement(AddUserFormContent, { isAddUserError: isManageUserError, onCancel: handleCancel })))));
};
ManageUserForm.displayName = 'ManageUserForm';
